module.exports = __webpack_public_path__ + "482b7a9c7d8f04f49e0b83d2a5b4290e.png";